//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'axios'
import { SyncLoader } from '@saeris/vue-spinners'
//


export default {
  components: {
    SyncLoader,
  },

  data() {
    return {
      stores: [],
      loading: false,
      searchText: '',
      map: null,
      markers: [],
      storeMarkers: {},
      infoWindow: null,
      mapSettings: {
        zoom: 5.5,
        center: {
          lat: 42.09219671376909,
          lng: 12.523709025007907,
        },
      },
    }
  },

  computed: {
    clusterIcon: function() {
      try {
        if (!mapData.clusterIcon.sizes.mini) {
          throw new Error('No cluster icon setup')
        }

        return mapData.clusterIcon.sizes.mini
      } catch (error) {
        return 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png'
      }
    },

    markerIcon: function() {
      try {
        if (!mapData.clusterIcon.sizes.mini) {
          throw new Error('No marker icon setup')
        }

        return mapData.markerIcon.sizes.mini
      } catch (error) {
        return 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
      }
    },

    i18n: function() {
      return wpData.i18n
    },
  },

  watch: {
    stores: function (newStore, oldStores) {
      try {
        this.removeAllMarkers()

        newStore.map((store) => {
          if (!store.acf.position.lat || !store.acf.position.lng) return;

          const position = {
            lat: Number(store.acf.position.lat),
            lng: Number(store.acf.position.lng),
          }

          const marker = new google.maps.Marker({
            position,
            map: this.map,
            icon: this.markerIcon,
          });

          marker.addListener('click', () => {
            this.openInfoWindow({ store, marker })
          });

          this.storeMarkers[store.id] = marker 

          if (marker) this.markers.push(marker)
        })

        new MarkerClusterer(this.map, this.markers, {
          styles: [{
            url: this.clusterIcon,
            width: 60,
            height: 60,
            // anchorText: [0, 0],
            anchorIcon: [20, 20],
            textSize: 20,
            textColor: '#273488',
          }],
        });

        this.setMapBounds()
      } catch (error) {
        console.log('Error', error)
      }
    },
  },

  mounted() {
    this.fetchResults()

    this.initMap()
  },

  methods: {
    handleSubmit: function() {
      const wrapperY = this.$refs.wrapper.getBoundingClientRect().top + window.scrollY
      const headerHeight = document.querySelector('.main-header').getBoundingClientRect().height

      console.log('ppp', this.$refs.wrapper.getBoundingClientRect().top, window.scrollY)
      console.log('wrapperY', wrapperY, headerHeight)

      window.scrollTo(0, wrapperY - headerHeight)

      this.fetchResults()
    },

    fetchResults: function() {
      this.loading = true

      get(`${wpData.baseApi}/store`, {
        params: {
          per_page: 200,
          search: this.searchText,
          order: 'asc',
          orderby: 'title',
        },
      })
        .then((res) => {
          this.stores = res.data
        })
        .catch((error) => {
          console.log('error', error)
        })
        .then(() => {
          this.loading = false
        })
    },

    initMap: function() {
      this.map = new google.maps.Map(this.$refs.map, this.mapSettings);

      this.infoWindow = new google.maps.InfoWindow();
    },

    removeAllMarkers: function() {
      this.markers.forEach((marker) => {
        marker.setMap(null);
      })      

      this.markers = []
      this.storeMarkers = {}
    },

    setMapBounds: function() {
      const bounds = new google.maps.LatLngBounds()

       this.markers.forEach((marker) => {
        const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng)
      })

      if (!this.map) return

      if (this.markers.length == 0) {
        this.map.setCenter(this.mapSettings.center);
        this.map.setZoom(this.mapSettings.zoom);

      } else if (this.markers.length == 1) {
        // set center of map
        this.map.setCenter(bounds.getCenter());
        this.map.setZoom(14);
      } else {
        this.map.fitBounds(bounds)
      }
    },

    centerMapOnStore: function(store) {
      const position = {
        lat: Number(store.acf.position.lat),
        lng: Number(store.acf.position.lng),
      }


      this.map.setCenter(position)
      this.map.setZoom(14);

      this.openInfoWindow({ store })

      if ($(window).width() > 1023) {
        return;
      }

      if ($(window).width() > 767) {
        var top = map.offsetTop - 148;
      } else {
        var top = map.offsetTop - 88;
      }

      window.scrollTo(0, top);
    },

    openInfoWindow: function({ store, marker }) {
      const position = {
        lat: Number(store.acf.position.lat),
        lng: Number(store.acf.position.lng),
      }
      const infoWindowContent = `<div class="info-window-wrapper"><h3 class="info-window-title">${store.title.rendered}</h3><div class="info-window-content">${store.acf.address}</div></div>`
      this.infoWindow.setContent(infoWindowContent)
      
      this.infoWindow.open(this.map, this.storeMarkers[store.id])
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/components/StoreLocator.vue